import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import ProgressBar from '../ProgressBar'
import {
  Text,
  TEXT_VARIANT_LIGHT,
  TEXT_VARIANT_SMALL_LIGHT,
  Flex
} from 'mailup-web-components'

import {
  SENDING_SOURCE_UNDEFINED,
  SENDING_STATUS_QUEUECANCELLED,
  SENDING_STATUS_QUEUECOMPLETED,
  SENDING_STATUS_QUEUEFAILED,
  SENDING_STATUS_QUEUERUNNING,
  SENDING_STATUS_QUEUETOEXECUTED
} from 'Constants/index'
import styled from '@emotion/styled'

const StatusCell = ({ status, source, isStopped, ABTestStatus, progress }) => {
  const intl = useIntl()

  let stringId = ''
  const classNameList = []

  switch (status) {
    case SENDING_STATUS_QUEUECANCELLED:
      stringId = 'Load.Schedulation.QueueCancelled'
      break
    case SENDING_STATUS_QUEUETOEXECUTED:
      stringId = 'Load.Schedulation.QueueToExecute'
      break
    case SENDING_STATUS_QUEUEFAILED:
      stringId = 'Load.Schedulation.QueueFailed'
      classNameList.push('c-sendstatus-item__status--danger')
      break
    case SENDING_STATUS_QUEUECOMPLETED:
      if (source === SENDING_SOURCE_UNDEFINED) {
        stringId = 'Load.Schedulation.QueueCompleted'
      } else {
        if (isStopped) {
          stringId = 'Load.Schedulation.StatusStopped'
        }
      }
      break
  }

  const showProgress = status === SENDING_STATUS_QUEUERUNNING && !ABTestStatus

  return (
    <Flex
      className={`'c-sendstatus-item__status' ${classNameList}`}
      padding='24px 16px'
    >
      {stringId && (
        <Text variant={TEXT_VARIANT_LIGHT}>
          {intl.formatMessage({ id: stringId })}
        </Text>
      )}
      {!!progress && showProgress && (
        <Flex flexDirection='column'>
          <Text variant={TEXT_VARIANT_LIGHT}>
            <em>
              {intl.formatMessage({ id: 'Load.Schedulation.QueueInProgress' })}
            </em>
          </Text>
          <ProgressBar min={0} max={1} value={progress}>
            <StyledSmallText variant={TEXT_VARIANT_SMALL_LIGHT}>
              {intl.formatNumber(progress, {
                style: 'percent',
                maximumFractionDigits: 0
              })}
            </StyledSmallText>
          </ProgressBar>
        </Flex>
      )}
    </Flex>
  )
}

export default StatusCell

StatusCell.propTypes = {
  status: PropTypes.any,
  source: PropTypes.any,
  isStopped: PropTypes.bool,
  ABTestStatus: PropTypes.any,
  progress: PropTypes.number
}

const StyledSmallText = styled(Text)`
  font-size: 12px !important;
`
